// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-override .scroll {\n  max-height: inherit;\n  height: 100%;\n}\n.scroll-override .scroll ul {\n  padding-bottom: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
